var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,19.2c-2.2,0-4.4,0-6.6,0c-1.5,0-2.6-1.1-2.6-2.6c0-4.4,0-8.8,0-13.2c0-1.3,0.8-2.3,2.1-2.5c0.1,0,0.3,0,0.4,0 c1.9,0,3.9,0,5.8,0c0.4,0,0.7,0.2,0.8,0.6c0.1,0.4,0,0.8-0.4,0.9C9.4,2.4,9.3,2.5,9.1,2.5c-1.9,0-3.8,0-5.7,0 c-0.6,0-0.9,0.3-0.9,0.9c0,4.4,0,8.8,0,13.2c0,0.6,0.3,0.9,0.9,0.9c4.4,0,8.8,0,13.2,0c0.5,0,0.9-0.3,0.9-0.9c0-1.9,0-3.8,0-5.8 c0-0.4,0.3-0.8,0.7-0.8c0.4-0.1,0.8,0.2,0.9,0.6c0,0.1,0,0.2,0,0.3c0,1.9,0,3.9,0,5.8c0,1.4-1.1,2.5-2.5,2.5 C14.4,19.2,12.2,19.2,10,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0.8c0.7,0,1.3,0.2,1.8,0.7c0.3,0.3,0.7,0.7,0.9,1.1c0.6,0.9,0.4,2.2-0.4,3c-2.9,2.9-5.8,5.8-8.7,8.7 c-0.5,0.5-1.1,0.9-1.9,1c-0.5,0.1-1,0.2-1.6,0.3c-1.3,0.3-2.3-0.8-2-2c0.1-0.6,0.3-1.3,0.4-1.9c0.1-0.5,0.3-0.9,0.7-1.2 c3-3,6-6,8.9-8.9C14.7,1.1,15.3,0.8,16,0.8z M12.6,5.5C12.6,5.5,12.6,5.6,12.6,5.5c-2.1,2.1-4.1,4.1-6.1,6.1 c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.4-0.2,0.8-0.3,1.3c-0.1,0.2-0.1,0.5-0.2,0.7c0.6-0.1,1.2-0.3,1.8-0.4c0.3-0.1,0.6-0.2,0.8-0.4 c1.9-2,3.9-3.9,5.8-5.8c0,0,0.1-0.1,0.1-0.1C13.8,6.7,13.2,6.1,12.6,5.5z M15.5,6.1c0.5-0.5,1.1-1.1,1.6-1.6c0.3-0.3,0.3-0.8,0-1.1 c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.3-0.8-0.3-1.1-0.1c-0.6,0.5-1.1,1.1-1.7,1.7C14.4,4.9,15,5.5,15.5,6.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d9b211996eadbd7bff9321ab1df886fc.svg";
export { ForwardRef as ReactComponent };